import { Outlet } from "react-router-dom";
import Header from "../components/mainPage/header";
import NavBar from "../components/mainPage/navbar";
import EditBox from "../components/posPage/editBox";
import { useContext, useEffect } from "react";
import { context } from "../context/context";
import ClientInfo from "../components/posPage/clientInfo";
import RemoveItem from "../components/removeItem";
import {displayData, mainSearch, recodeNow, StoreDB} from '../components/indexDB/indexDBStora';
import { dataa } from "../context/data";
import { switchh } from "../context/switch";
import DisplayInvoice from "../components/displayInvoice";
import Attendance from "../components/mainPage/attendance";
import { scenes } from "../context/scenes";
import ShowDetails from "../components/empPage/showDetails";
import { collection } from "../context/collect";
import { Setting } from "../context/settings";
import PayMethodPage from "../components/posPage/PayOnline";
import { action } from "../context/action";
import { intialData } from "../context/initial";
import GetAccess from "../components/getAccess";
import ResetCodeHolder from "../components/settings/ResetCodeHolder";
import AddWeight from "../components/addWeight";
import { auth } from "../context/auth";
import Testcategories from '../data/test/categories.json';
import { config } from "../context/config";
import useShortKeys from "../funcs/hooks/useShortKey";
import FormAddProductInventroy from "../components/inverstoryPage/FormAddProductInventroy";

export default function Main () {
    const { isDesktop } = useContext(config);
    const { setCategory, setProducts, scene, setInvestors, paymentStatus, setSuppliers } = useContext(dataa);
    const { user } = useContext(auth);
    const { enableDelivery, loadingProcess, enableAttendance, access, enableSendResetCode, enableAddWeightManully, enableAddInInvenotry } = useContext(switchh);
    const { setCconfig, setCsocial, setCinvoice, setCbusinessRules } = useContext(collection);
    const { intialConfig, intialSocial, intialInvoice, initialWork } = useContext(intialData);
    const { edit, deleteBox, clientFlag } = useContext(context);
    const { enablePayOnline } = useContext(action);
    const { sceneEmp } = useContext(scenes);
    const { setStoreConfig, setStoreSociety, setStoreInvoice, setStoreBusniessRules } = useContext(Setting);
    
    useEffect(() => {
    let isMounted = true;

    const fetchAllData = async () => {
    try {
        const [
            categories,
            warehouse,
            products,
            suppliers,
            config,
            social,
            invoice,
            work
        ] = await Promise.all([
            displayData("categories"),
            displayData("warehouse"),
            displayData("products"),
            displayData("suppliers"),
            mainSearch("settings", "configuration"),
            mainSearch("settings", "social"),
            mainSearch("settings", "invoice"),
            mainSearch("settings", "businessRules")
        ]);

        if (!isMounted) return;

        let containerCategories;
        if(config?.workMode === "test") {
            containerCategories = Testcategories;
        }
        else {
            containerCategories = categories;
        }
        // set data
        setCategory(containerCategories || []);
        setInvestors(warehouse || []);
        setProducts(products || []);
        setSuppliers(suppliers || []);

        // settings
        if (!config) {
            await recodeNow(intialConfig, "settings");
        } else {
            setCconfig(config);
            setStoreConfig(config);
        }

        if (!social) {
            await recodeNow(intialSocial, "settings");
        } else {
            setCsocial(social);
            setStoreSociety(social);
        }

        if (!invoice) {
            await recodeNow(intialInvoice, "settings");
        } else {
                setCinvoice(invoice);
                setStoreInvoice(invoice);
            }

            if (!work) {
                await recodeNow(initialWork, "settings");
            } 
            else {
                setCbusinessRules(work);
                setStoreBusniessRules(work);
            }
        } 
        catch (err) {
            console.error("Error loading data:", err);
        }
    };

    fetchAllData();

    return () => {
        isMounted = false;
    };

    }, [loadingProcess]);


    useEffect(() => {
        const LocalStore = async () => {
            await StoreDB();
        };
        LocalStore();

    }, [])

    // set shortKeys to specific data
    useShortKeys();
    return (
        <div className="main">
            {Object.keys(edit).length !== 0 && <EditBox currency={user.data[0]?.currency.code} data={edit} />}
            {enableDelivery && <ClientInfo mode={clientFlag}/>}
            {enableAttendance && <Attendance />}
            {deleteBox.status && <RemoveItem id={deleteBox.id} />}
            {enablePayOnline.status && !paymentStatus?.status && <PayMethodPage isDesktop={isDesktop} currency={user.data[0]?.currency.symbol} cash={enablePayOnline.cash} benefits={enablePayOnline.benefits} moneyVisa={enablePayOnline.totalVisa} />}
            {scene.length !== 0 && <DisplayInvoice data={scene} />}
            {sceneEmp?.code && <ShowDetails data={sceneEmp} currency={user.data[0]?.currency.code} />}
            {access && <GetAccess />}
            {enableSendResetCode && <ResetCodeHolder />}
            {enableAddWeightManully.status && <AddWeight data={enableAddWeightManully.data} />}
            {Object.keys(enableAddInInvenotry).length !== 0 && <FormAddProductInventroy inventory={enableAddInInvenotry} /> }
            <Header />
            <NavBar/>
            <Outlet />
        </div>
    )
}